import { render } from "./Drops.vue?vue&type=template&id=46d1373e"
import script from "./Drops.vue?vue&type=script&lang=js"
export * from "./Drops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__